<template>
  <nav class="fixed w-full z-50 transition-all duration-500 bg-white/60 dark:bg-slate-900/60 backdrop-blur-xl border-b border-white/30 dark:border-indigo-300/10 shadow-[0_8px_30px_rgba(15,23,42,0.12)] dark:shadow-[0_10px_40px_rgba(2,6,23,0.45)]">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-16">
        <div class="flex items-center">
          <NuxtLink to="/" class="flex-shrink-0 flex items-center">
            <div class="relative h-8 w-[90px] flex-shrink-0 drop-shadow-[0_0_10px_rgba(59,130,246,0.25)]">
              <img
                src="/logo.svg"
                alt="MAGIC Logo"
                class="h-8 w-auto absolute inset-0 transition-opacity duration-300 dark:opacity-0"
              >
              <img
                src="/logo-white.svg"
                alt="MAGIC Logo"
                class="h-8 w-auto absolute inset-0 transition-opacity duration-300 opacity-0 dark:opacity-100"
              >
            </div>
          </NuxtLink>
          <div class="hidden lg:block ml-8">
            <div class="flex items-baseline space-x-1">
              <NuxtLink 
                v-for="item in navigation" 
                :key="item.name" 
                :to="item.href"
                class="text-gray-700 dark:text-slate-300 hover:text-gray-900 dark:hover:text-white px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-blue-50/80 dark:hover:bg-indigo-500/15 relative group"
                :class="{ 'text-primary bg-primary-100/80 dark:bg-indigo-500/20 dark:text-indigo-100': isActiveRoute(item.href) }"
              >
                {{ item.name }}
                <span class="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full"></span>
              </NuxtLink>
            </div>
          </div>
        </div>
        
        <div class="hidden md:flex items-center space-x-3">
          <ThemeToggle />
          <NuxtLink to="/login" class="text-sm font-medium text-gray-600 dark:text-dark-muted hover:text-gray-900 dark:hover:text-dark-text px-4 py-2 rounded-lg hover:bg-blue-50 dark:hover:bg-primary-900/30 transition-all duration-300">
            登录
          </NuxtLink>
          <button 
            @click="scrollToContact"
            class="text-sm font-medium bg-primary hover:bg-primary-700 text-white px-4 py-2 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            开始使用
          </button>
        </div>
        
        <div class="flex lg:hidden items-center space-x-2">
          <ThemeToggle />
          <button @click="mobileMenuOpen = !mobileMenuOpen" 
                  class="inline-flex items-center justify-center p-2 rounded-lg text-gray-600 dark:text-dark-muted hover:text-gray-900 dark:hover:text-dark-text hover:bg-blue-50 dark:hover:bg-primary-900/30 focus:outline-none transition-all duration-300">
            <span class="sr-only">打开主菜单</span>
            <svg v-if="!mobileMenuOpen" class="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <svg v-else class="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <div v-if="mobileMenuOpen"
         class="lg:hidden bg-white/90 dark:bg-dark-card/90 backdrop-blur-md border-t border-gray-200/50 dark:border-dark-border/50 animate-slide-down">
      <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
        <NuxtLink 
          v-for="item in navigation" 
          :key="item.name"
          :to="item.href"
          @click="mobileMenuOpen = false"
          class="text-gray-600 dark:text-dark-muted hover:text-gray-900 dark:hover:text-dark-text block px-3 py-3 rounded-md text-base font-medium transition-all duration-300 hover:bg-blue-50 dark:hover:bg-primary-900/30"
          :class="{ 'text-primary bg-primary-100 dark:bg-primary-900/30': isActiveRoute(item.href) }"
        >
          {{ item.name }}
        </NuxtLink>
        <div class="px-3 py-4 space-y-2 border-t border-gray-200 dark:border-dark-border mt-2">
          <NuxtLink to="/login" @click="mobileMenuOpen = false" class="block w-full text-center text-gray-600 dark:text-dark-muted hover:text-gray-900 dark:hover:text-dark-text px-4 py-2 rounded-lg hover:bg-blue-50 dark:hover:bg-primary-900/30 transition-all duration-300">
            登录
          </NuxtLink>
          <button 
            @click="scrollToContact(); mobileMenuOpen = false"
            class="w-full bg-primary hover:bg-primary-700 text-white px-4 py-2 rounded-lg transition-all duration-300"
          >
            开始使用
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const mobileMenuOpen = ref(false)

const navigation = [
  { name: '首页', href: '/' },
  { name: '产品', href: '/products' },
  { name: '解决方案', href: '/solutions' },
  { name: '案例', href: '/cases' },
  { name: '关于', href: '/about' },
  // { name: '资讯', href: '/news' },
]

const isActiveRoute = (href) => {
  return route.path === href
}

const scrollToContact = () => {
  // 直接跳转到关于页面的联系模块
  window.location.href = '/about#contact'
}

const navigateToContact = () => {
  // 跳转到关于页面的联系模块
  window.location.href = '/about#contact'
}
</script>
